/**
 * 怎么查
 * 传查询类型
 *
 * 兑换活动的优惠券信息查询： /app/task/exch_act_prize_info.cgi
 * 普通查询优惠券信息：/app/promotion/prom_qry_simplecoup_info.cgi
 * 查询连锁券信息：/app/promotion/prom_qry_combincoup_info.cgi
 */
import { exchActPrizeInfo, userCouponList, qryChainCoupInfo, promShowGoodsInfo, GoodsType } from '@tencent/wphk-act-base-cgi';
import { formatExchActPrizeInfo, getDisplayCouponState } from './format-coupon';
/** 查券类型 */
export var QryCouponType;
(function (QryCouponType) {
    /** 兑换活动的优惠券信息查询 - 通过资格、印花 id 查 */
    QryCouponType["ExchActPrizeInfoByQualId"] = "ExchActPrizeInfoByQualId";
    /** 兑换活动的优惠券信息查询 - 通过活动 id 查 */
    QryCouponType["ExchActPrizeInfoByActId"] = "ExchActPrizeInfoByActId";
    /** 普通查询优惠券信息 */
    QryCouponType["QrySimplecoupInfo"] = "QrySimplecoupInfo";
    /** 查询连锁券信息 */
    QryCouponType["QryCombincoupInfo"] = "QryCombincoupInfo";
    /** 查询并列式连锁券信息 */
    QryCouponType["QryDisplayCombincoupInfo"] = "QryDisplayCombincoupInfo";
    /** 查用户自己的券 */
    QryCouponType["QryUserCouponList"] = "QryUserCouponList";
})(QryCouponType || (QryCouponType = {}));
/**
 * 兑换活动的优惠券信息查询 - 通过资格、印花 id 查
 * @param actType 活动类型
 * @param couponActRelation 券和活动对应关系
 * @param stampInfo 印花信息
 * @returns
 */
export async function toExchActPrizeInfoByQualId(actType, couponActRelation, stampInfo) {
    const { stampBatchNo } = stampInfo;
    const data = await exchActPrizeInfo({ qualIdList: stampBatchNo, statUserCpn: 1, qryQualAct: 1 });
    const couponList = formatExchActPrizeInfo({
        actType,
        couponActRelation,
        data: Object.assign(Object.assign({}, data), { exchActidList: data.qualExchActidList }),
        stampInfo,
    });
    return couponList;
}
/**
 * 兑换活动的优惠券信息查询 - 通过活动 id 查
 * @param actType 活动类型
 * @param couponActRelation 券和活动对应关系
 * @param distributeActidList 派发活动列表
 * @returns
 */
export async function toExchActPrizeInfoByActId(actType, couponActRelation, distributeActidList) {
    const data = await exchActPrizeInfo({ exchActidList: distributeActidList, statUserCpn: 1, qryQualAct: 1 });
    const couponList = formatExchActPrizeInfo({
        actType,
        couponActRelation,
        data,
    });
    return couponList;
}
/** 普通查询优惠券信息 */
export async function toQrySimplecoupInfo(params) { }
/** 查询连锁券信息 */
export async function toQryCombincoupInfo(actListId) {
    const data = await qryChainCoupInfo({
        actListId,
    });
    return data.couponList;
}
/** 查询并列式连锁券信息 */
export async function toQryDisplayCombincoupInfo(actListId) {
    var _a;
    const [actData, chainData] = await Promise.all([
        exchActPrizeInfo({
            exchActidList: actListId,
            showActQuota: 1,
        }),
        qryChainCoupInfo({
            actListId,
        }),
    ]);
    // 券静态配置信息
    const goodsIdList = chainData.couponArr.map(coupon => coupon.couponId);
    const { goodsArr } = await promShowGoodsInfo({
        goodsType: GoodsType.coupon,
        goodsIdList,
    });
    // 当前解锁了的券id
    const curCanAvaliableCouponId = (_a = chainData.couponList[0]) === null || _a === void 0 ? void 0 : _a.couponId;
    // 当前系统时间
    const curSysTime = chainData.sysTime;
    const couponList = chainData.couponArr.map((chainCoupon) => {
        const actInfo = actData.exchActidList.find((enExAct) => enExAct.prizeId === chainCoupon.couponId);
        const goodInfo = goodsArr.find(item => item.goodsEnId === chainCoupon.couponId);
        return {
            chainCoupon,
            actInfo,
            goodInfo,
            couponState: getDisplayCouponState(chainCoupon, actInfo, curCanAvaliableCouponId, curSysTime),
        };
    });
    return couponList;
}
export async function toQryUserCouponList(couponIdList) {
    const data = await userCouponList({ couponIdList });
    return [...(data.cpInfo || []), ...(data.spInfo || [])];
}
/** 查券 */
export const handleQryCoupon = {
    /** 兑换活动的优惠券信息查询 - 通过资格、印花 id 查 */
    [QryCouponType.ExchActPrizeInfoByQualId]: toExchActPrizeInfoByQualId,
    /** 兑换活动的优惠券信息查询 - 通过活动 id 查 */
    [QryCouponType.ExchActPrizeInfoByActId]: toExchActPrizeInfoByActId,
    /** 普通查询优惠券信息 */
    [QryCouponType.QrySimplecoupInfo]: toQrySimplecoupInfo,
    /** 查询连锁券信息 */
    [QryCouponType.QryCombincoupInfo]: toQryCombincoupInfo,
    /** 查询并列式连锁券信息 */
    [QryCouponType.QryDisplayCombincoupInfo]: toQryDisplayCombincoupInfo,
    /** 查用户自己的券 */
    [QryCouponType.QryUserCouponList]: toQryUserCouponList,
};
